/* k4k-vat.js: Ex VAT / Inc VAT display switch.
   - Default is ex VAT for everybody; the choice is stored in localStorage ("k4k_vat") only when the visitor presses a button.
   - Prices printed by the theme come as two spans (.k4k-ex / .k4k-inc, see snippets/k4k-money.liquid + price.liquid); CSS picks one.
   - This file additionally (a) handles the toggle UI, (b) rewrites loose text in inc mode ("Prices exclude VAT" -> "Prices include VAT", "per cartridge" prices,
     the Loop subscription widget amounts) and puts it back in ex mode, (c) tells other scripts (quantity bar, sticky bar) via the "k4k-vat-change" event.
   - The cart, cart drawer and checkout always stay EX VAT (they are the real figures); in inc mode the cart adds an "estimated total inc VAT" line.
   - Structured data, meta tags and the Google feed are never touched (they stay ex VAT). */
(function () {
  var root = document.documentElement, RATE = 1.2;
  var SKIP = 'script,style,textarea,noscript,title,.k4k-vat,.k4k-ex,.k4k-inc,.k4k-vat-est,cart-drawer,cart-notification,#main-cart-items,#main-cart-footer,form#cart,[data-k4k-vat-skip]';
  var orig = new WeakMap(), out = new WeakMap(), mode = root.getAttribute('data-k4k-vat') === 'inc' ? 'inc' : 'ex';
  var onCart = /^\/cart\/?$/.test(location.pathname);

  function pounds(x) { return '\u00a3' + (Math.round(x * RATE * 100) / 100).toFixed(2); }
  function conv(s, loop) {
    var t = s
      .replace(/\(20% VAT is added at checkout\)/g, '(at 20%)')
      .replace(/Prices exclude VAT/g, 'Prices include VAT')
      .replace(/Prices ex VAT/g, 'Prices inc VAT')
      .replace(/\u00a3(\d+(?:\.\d+)?)( per cartridge)( ex VAT)?/g, function (m, a, b) { return pounds(parseFloat(a)) + b + ' inc VAT'; })
      .replace(/\bEx VAT\b/g, 'Inc VAT').replace(/\bex VAT\b/g, 'inc VAT');
    if (loop) t = t.replace(/\u00a3(\d[\d,]*(?:\.\d+)?)/g, function (m, a) { return pounds(parseFloat(a.replace(/,/g, ''))); });
    return t;
  }
  function inLoop(n) { var e = n.parentElement; return !!(e && e.closest && e.closest('[class*="loop-"],[id*="loop-"],[class*="Loop"],[id*="loop_"]')); }
  function skipped(n) {
    var e = n.parentElement; if (!e || !e.closest) return true;
    if (e.closest(SKIP)) return true;
    return false;
  }
  function text(n) {
    var v = n.nodeValue; if (!v) return;
    if (mode === 'inc') {
      if (out.get(n) === v) return;               // our own output
      if (skipped(n)) return;
      if (!/VAT|\u00a3/.test(v)) return;
      var loop = inLoop(n);
      if (!loop && !/VAT|per cartridge/.test(v)) return;        // plain amounts are only rewritten inside the subscription widget
      var o = conv(v, loop);
      orig.set(n, v);
      if (o !== v) { out.set(n, o); n.nodeValue = o; } else { out.delete(n); }
    } else if (out.has(n) && out.get(n) === v) {
      n.nodeValue = orig.get(n); out.delete(n);
    }
  }
  function walk(node) {
    if (!node) return;
    if (node.nodeType === 3) { text(node); return; }
    if (node.nodeType !== 1) return;
    var w = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) text(n);
  }
  // Mutations are handled in a short timer (not inside the observer callback) so a widget that rewrites its own text can never lock the page.
  var pending = new Set(), timer = null, count = new WeakMap();
  function flush() {
    timer = null;
    var items = Array.from(pending); pending.clear();
    items.forEach(function (n) {
      if (!n.isConnected) return;
      if (n.nodeType === 3) {
        var c = (count.get(n) || 0);
        if (c > 8) return;                      // give up on a node that something keeps rewriting
        var before = n.nodeValue; text(n);
        if (n.nodeValue !== before) count.set(n, c + 1);
      } else walk(n);
    });
    if (mode === 'inc') root.classList.remove('k4k-vat-wait');
  }
  var mo = new MutationObserver(function (list) {
    list.forEach(function (m) {
      if (m.type === 'characterData') pending.add(m.target);
      else m.addedNodes.forEach(function (a) { if (a.nodeType === 1 || a.nodeType === 3) pending.add(a); });
    });
    if (!timer && pending.size) timer = setTimeout(flush, 50);
  });
  function watch() { mo.observe(document.body, { childList: true, subtree: true, characterData: true }); }
  function unwatch() { mo.disconnect(); pending.clear(); }

  function setButtons() {
    document.querySelectorAll('[data-k4k-vat-set]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-k4k-vat-set') === mode ? 'true' : 'false');
    });
  }
  function apply(announce) {
    unwatch();
    root.setAttribute('data-k4k-vat', mode);
    walk(document.body);
    setButtons();
    watch();
    root.classList.remove('k4k-vat-wait');
    document.dispatchEvent(new CustomEvent('k4k-vat-change', { detail: { mode: mode } }));
    if (announce) {
      document.querySelectorAll('[data-k4k-vat-live]').forEach(function (l) {
        l.textContent = mode === 'inc' ? 'Prices now shown including VAT.' : 'Prices now shown excluding VAT.';
      });
    }
  }
  function choose(m) {
    if (m === mode) return;
    mode = m;
    try { window.localStorage.setItem('k4k_vat', m); } catch (e) {}
    apply(true);
  }
  function init() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-k4k-vat-set]');
      if (b) choose(b.getAttribute('data-k4k-vat-set'));
    });
    window.addEventListener('storage', function (e) {          // keep several open tabs in step
      if (e.key === 'k4k_vat') { var m = e.newValue === 'inc' ? 'inc' : 'ex'; if (m !== mode) { mode = m; apply(false); } }
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { try { var m = localStorage.getItem('k4k_vat') === 'inc' ? 'inc' : 'ex'; if (m !== mode) { mode = m; apply(false); } } catch (x) {} } });
    apply(false);
    // Late-rendering apps (subscription widget): look again a few times after load
    [800, 2000, 4500].forEach(function (t) { setTimeout(function () { if (mode === 'inc') { unwatch(); walk(document.body); watch(); } }, t); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
